export default __webpack_public_path__ + "static/media/neblina.069a97ad.svg";